import store from "@/store";
import { getFromLocalStorage } from "@/utils/localstorage";

export default async function authOrRedirectToWL({ next, to, router }) {
  store.commit("auth/clearErrors");
  const token = getFromLocalStorage("authtoken", null);

  if (!token || !store.getters["user/getCurrentUser"]) {
    return (window.location = `${process.env.VUE_APP_LANDING_PAGE}/offer/weight-loss-programme-getlabtest`);
  }

  return next();
}
